import { Link } from 'react-router-dom';
import { RouteObject } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import Home from '@/pages/home/page';
import Category from '@/pages/category/page';
import ArticlePage from '@/pages/article/page';
import About from '@/pages/about/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: 'category/:slug',
        element: <Category />,
      },
      {
        path: 'article/:slug',
        element: <ArticlePage />,
      },
      {
        path: 'about',
        element: <About />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
];

export default routes;